// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2nkNt","empty":"ModalGraph_empty__1JOYs"};